import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  vehicleListData: [],
  isSuccess: false,
  totalCount: 0,
  currentpage: 1,
  totalPages: 1,
  apiMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.INVENTORY_GET_VEHICLE_LIST_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
      };
    case actionConstants.INVENTORY_GET_VEHICLE_LIST_SUCCESS:
      return {
        ...state,
        vehicleListData:
          action.payload.page === 1
            ? action.payload.docs
            : [...state.vehicleListData, ...action.payload.docs],
        isfetching: false,
        totalCount: action.payload.total,
        currentpage: action.payload.page,
        totalPages: action.payload.pages,
        isSuccess: true,
      };
    case actionConstants.INVENTORY_GET_VEHICLE_LIST_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
      };
    case actionConstants.INVENTORY_GET_VEHICLE_LIST_RESET:
      return {
        ...state,
        error: '',
        isSuccess: false,
      };

    default:
      return state;
  }
};
